import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Root, Thumb } from '@radix-ui/react-switch';

const Switch = /*#__PURE__*/forwardRef(function Switch(props, ref) {
  const {
    label,
    onChange,
    ...otherProps
  } = props;
  const className = cn('group h-5 w-9 flex flex-shrink-0 rounded-full inline-flex', {
    'mr-2': !!label,
    'bg-grey-darker hover:bg-grey-dark aria-checked:bg-blue aria-checked:hover:bg-blue-light focus:yt-focus': !props.disabled,
    'bg-grey-light cursor-not-allowed aria-checked:bg-blue-light': props.disabled
  }, props.className);
  const element = createElement(Root, Object.assign({}, otherProps, {
    className: className,
    onCheckedChange: onChange,
    ref: ref
  }), createElement(Thumb, {
    className: "'will-change-transform group-aria-checked:translate-x-[1.1rem] mt-0.5 h-4 w-4 translate-x-[0.15rem] rounded-full bg-white transition-transform group-disabled:opacity-50"
  }));

  if (label) {
    const labelClassName = cn('flex self-start cursor-pointer', {
      'cursor-not-allowed text-grey-dark': props.disabled
    });
    return createElement("label", {
      className: labelClassName
    }, element, label);
  }

  return element;
});

export { Switch };
//# sourceMappingURL=Switch.js.map
